import { z } from 'zod';
import { TenantTypeSchema } from '../../entities/tenant/tenant.schema';
import { UserTypeSchema } from '../../entities/user/user.schema';
import { PlatformRoleSchema } from '../../entities/user/platform-role';
import { AvatarSchema } from '../../shared/avatar.schema';
import { SupportedLanguageSchema } from '../../shared/language.schema';
/**
 * Signed-In Session User Schema
 * Subset of User fields returned when a session is established
 */ export const SignInResponseUserSchema = z.object({
    _id: z.string(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    avatar: AvatarSchema.optional(),
    userTypes: z.array(UserTypeSchema),
    /**
   * Was dieser Mensch an der Plattform darf (ADR 0042) — leer bei jedem, der
   * über einen Mandanten kommt. Die Oberfläche blendet danach aus; abgelehnt
   * wird trotzdem am Server, denn eine Regel, die nur der Browser kennt, ist
   * keine.
   */ platformRoles: z.array(PlatformRoleSchema),
    language: SupportedLanguageSchema.optional()
});
/**
 * Tenant type as a session sees it: the real tenant types plus 'super' for
 * the staff pseudo-tenant, which has no Tenant document behind it.
 */ export const SessionTenantTypeSchema = z.enum([
    'super',
    ...TenantTypeSchema.options
]);
/**
 * Signed-In Session Schema
 * Returned whenever authentication establishes a session (SSO callback,
 * tenant switch)
 */ export const SignInResponseSchema = z.object({
    token: z.string(),
    tenant: z.object({
        _id: z.string(),
        slug: z.string(),
        name: z.string(),
        expiresAt: z.iso.datetime().nullable()
    }),
    tenantType: SessionTenantTypeSchema,
    user: SignInResponseUserSchema
});

//# sourceMappingURL=signed-in-session.schema.js.map